<template>
  <div
    v-loading="posterLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="dilog-box-loading">
    <div class="scale-wrapper" id="scaleWrapper" ref="scaleWrapper">
      <div ref="poster" id="poster" class="poster">
        <img
          src="./../assets/xi_112.jpg"
          alt="Background"
          class="background-image"
          @contextmenu.prevent="handleContextMenu"
        >

        <!-- 文字 -->
        <div class="poster-text">
          <div class="text-1">
            截至{{ formatDate(time) }}
          </div>
          <div class="text-2">
            <div>
              {{ name }}<span>网民参与答题</span>
            </div>
          </div>
          <div class="text-row">
            <div class="text-row-left">
              <div class="text-3">样本量</div>
              <div class="text-5">突破</div>
            </div>
            <div class="text-row-right">
              <div class="text-4">
                {{ formatNumber(totalAmount) }}<span>{{formatUnit(totalAmount)}}份</span>
              </div>
            </div>
          </div>
        </div>
        <div class="poster-text-left">
          <div>{{ rowData.amount }}<span>份</span></div>
        </div>
        <div class="poster-text-right">
          <div>{{ rowData.specialAmount }}<span>份</span></div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <template v-if="isPc">
        <el-button
          type="primary"
          @click="generatePoster"
        >
          保存本地
        </el-button>
      </template>
      <template v-else>
        <el-button
          type="primary"
          @click="openImg"
        >
          保存本地
        </el-button>
      </template>
    </div>
  </div>
</template>

<script>

import html2canvas from 'html2canvas';
export default {
  name: 'CustomButton',
  props: {
    type: {
      type: Number,
      default: 1
    },
    isPc: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: {
        amount: 0, // 主问卷总量
        specialAmount: 0, // 主问卷总量
      }
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {} // 默认点击事件为空函数
    }
  },
  data() {
    return {
      posterLoading: false,
      isWechat: /micromessenger/i.test(navigator.userAgent),
    }
  },
  created() {
    this.posterLoading = true;
    setTimeout(() => {
      this.posterLoading = false;
    }, 500);
    console.log('rowData', this.rowData)
  },
  mounted() {
    this.scalePoster();
    window.addEventListener('resize', this.scalePoster);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scalePoster);
  },
  methods: {
    handleContextMenu() {
      // 阻止右键菜单
      return false;
    },
    scalePoster() {
      const wrapper = this.$refs.scaleWrapper;
      if (!wrapper || window.innerWidth > 768) {
        wrapper.style.transform = '';
        return;
      } else if (!wrapper || window.innerWidth > 400) {
        wrapper.style.transform = `scale(0.6)`;
        wrapper.style.transformOrigin = 'center top';
      } else {
        wrapper.style.transform = `scale(0.58)`;
        wrapper.style.transformOrigin = 'center top';
      }
    },
    // 格式化数值的方法
    formatNumber(value) {
      if(value >= 10000) {
        return `${Math.floor(value / 10000)}`;
      } else if (value >= 1000) {
        return parseInt(value / 1000) * 1000;
      } else if (value >= 100) {
        return parseInt(value / 100) * 100;
      } else {
        return parseInt(value / 10) * 10;
      }
    },
    // 格式化数值的方法
    formatNumber_s(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.totalAmount >= 100000) {
        return (value / 10000).toFixed(4);
      } else {
        return value;
      }
    },
    formatUnit(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.totalAmount >= 100000 ) {
        return '万';
      } else {
        return '';
      }
    },
    handleImageLoad(event) {
      console.log('图片加载完成', event);
      this.posterLoading=false;
      // 执行图片加载完成后的逻辑
    },
    handleImageError(event) {
      console.log('图片加载失败', event);
      // 处理图片加载失败的逻辑
    },
    handleClick() {
      // 调用传入的点击事件处理器
      this.onClick();
    },
    openImg() {
      this.$nextTick(async () => {
        try {
          // 截图，scale 设为 3 提高分辨率
          const canvas = await html2canvas(this.$refs.scaleWrapper, {
            useCORS: true,
            backgroundColor: null,
            scale: 3,
          });

          // 生成预览
          const dataURL = canvas.toDataURL('image/png');
          this.previewImage(dataURL);
        } catch (err) {
          this.$message.error('生成图片失败');
        }
      });
    },
    previewImage(src) {
      // 方案1：弹层预览（推荐）
      document.body.style.overflow = 'hidden';
      const mask = document.createElement('div');
      mask.style.cssText = `
        position:fixed;right:0;bottom:0;inset:0;background:rgba(0,0,0,.85);
        display:flex;align-items:center;justify-content:center;
        z-index:9999;user-select:none;
      `;
      const img = document.createElement('img');
      img.src = src;
      img.style.cssText = `max-width:90%;max-height:90%;border-radius:8px;`;
      mask.appendChild(img);
      // 点空白关闭
      mask.addEventListener('click', () => document.body.removeChild(mask));
      document.body.appendChild(mask);
    },
    generatePoster() {
      this.$nextTick(()=>{
        if(this.$refs.scaleWrapper.id == 'scaleWrapper') {
          const posterElement = this.$refs.scaleWrapper;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
            scale: 3, // 提高分辨率
          }).then(canvas => {
            const posterImage = canvas.toDataURL('image/png', 1.0);
            // 在这里你可以保存或显示生成的海报图像
            // 如果要保存为文件，可以创建一个下载链接
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `${this.name}-${this.totalAmount}喜报.png`;
            link.click();
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })

    },
    formatDate(dateString) {
      // 将日期字符串转换为Date对象
      console.log('dateString',dateString)
      const dateStr = dateString.replace(/-/g,"/");
      console.log('dateStr',dateStr)
      const date = new Date(dateStr);

      // 获取月、日、小时、分钟
      const month = date.getMonth() + 1; // getMonth() 返回的月份是从0开始的
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // 格式化月、日、小时、分钟（补零）
      const monthStr = month < 10 ? `0${month}` : `${month}`;
      const dayStr = day < 10 ? `0${day}` : `${day}`;
      const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
      const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // 拼接格式化后的日期字符串
      return `${monthStr}月${dayStr}日 ${hoursStr}:${minutesStr}`;
    }
  }
};
</script>

<style scoped>
.dilog-box-loading {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
}
.poster {
  padding: 0;
  margin: 0;
  position: relative;
  width: 500px;
  height: calc(500px * (5118 / 2362));
  color: rgb(239, 81, 80);
}
.background-image {
  width: 100%;
  height: 100%;
}

.poster-text {
  position: absolute;
  left: 50%;
  top: 43.8%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.poster-text .text-1 {
  color: rgb(67, 67, 67);
  font-family: CustomFont6;
  letter-spacing: 1px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.poster-text .text-2 {
  font-family: CustomFont5;
  font-size: 46px;
  text-align: center;
  margin-top: 4px;
}
.poster-text .text-2 span{
  margin-left: 1rem;
  font-size: 36px;
}
.text-row {
  display: flex;
  justify-content: space-between;
  padding: 16px;
}
.text-row .text-row-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}
.poster-text .text-3{
  font-style: italic;
  font-family: monospace;
  font-size: 18px;
  text-align: center;
  line-height: 30px;
  letter-spacing: 6px;
}
.poster-text .text-5{
  font-style: italic;
  font-family: CustomFont6;
  letter-spacing: 10px;
  font-size: 46px;
  line-height: 56px;
  text-align: center;
  color: #FFEC9F;
  text-shadow:
    1px  1px 0.5px #EE3C37,  /* 增加 0.5px 模糊 */
    1px -1px 0.5px #EE3C37,
    -1px  1px 0.5px #EE3C37,
    -1px -1px 0.5px #EE3C37,
    0    1px 0.5px #EE3C37,
    0   -1px 0.5px #EE3C37,
    1px  0   0.5px #EE3C37,
    -1px  0   0.5px #EE3C37,
    5px  4px 0.5px #C84229;
}
.poster-text .text-4 {
  font-style: italic;
  font-family: CustomFont6;
  letter-spacing: 10px;
  margin-top: 4px;
  font-size: 92px;
  color: #FFEC9F;
  text-shadow:
    1px  1px 0.5px #EE3C37,  /* 增加 0.5px 模糊 */
    1px -1px 0.5px #EE3C37,
    -1px  1px 0.5px #EE3C37,
    -1px -1px 0.5px #EE3C37,
    0    1px 0.5px #EE3C37,
    0   -1px 0.5px #EE3C37,
    1px  0   0.5px #EE3C37,
    -1px  0   0.5px #EE3C37,
    4px  5px 0.5px #C84229;  /* 底部阴影也加一点模糊更自然 */
}
.poster-text .text-4 span {
  font-size: 46px;
  letter-spacing: 8px;
  margin-left: 4px;
}
.poster-text-left {
  position: absolute;
  top: 67.4%;
  left: 28%;
  transform: translateX(-50%);
  font-size: 42px;
  font-family: CustomFont6;
  font-weight: 600;
}
.poster-text-right {
  position: absolute;
  top: 67.4%;
  right: 28%;
  transform: translateX(50%);
  font-size: 42px;
  font-family: CustomFont6;
  font-weight: 600;
}
.poster-text-left span, .poster-text-right span {
  font-size: 24px;
  margin-left: 4px;
}

.btn-box {
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .btn-box {
    margin-top: calc( -960px * 0.42 );
  }
  .poster-text .text-5{
    text-shadow:
      1px  1px 0.5px #EE3C37,  /* 增加 0.5px 模糊 */
      1px -1px 0.5px #EE3C37,
      -1px  1px 0.5px #EE3C37,
      -1px -1px 0.5px #EE3C37,
      0    1px 0.5px #EE3C37,
      0   -1px 0.5px #EE3C37,
      1px  0   0.5px #EE3C37,
      -1px  0   0.5px #EE3C37,
      3px  2px 0.5px #C84229;
  }
  .poster-text .text-4 {
    text-shadow:
      1px  1px 0.5px #EE3C37,  /* 增加 0.5px 模糊 */
      1px -1px 0.5px #EE3C37,
      -1px  1px 0.5px #EE3C37,
      -1px -1px 0.5px #EE3C37,
      0    1px 0.5px #EE3C37,
      0   -1px 0.5px #EE3C37,
      1px  0   0.5px #EE3C37,
      -1px  0   0.5px #EE3C37,
      2px 3px 0.5px #C84229;
  }
}

@media screen and (max-width: 400px) {
  .btn-box {
    margin-top: calc( -960px * 0.45 );
  }
}

</style>



// WEBPACK FOOTER //
// src/components/posterCountry.vue